<template>
  <div class="site">
    <div class="site-header">
      <span>附近站点</span>
      <span class="site-tip">地图已下线，显示列表</span>
    </div>
    <div class="site-list">
      <div v-if="items.length===0" class="empty">暂无站点数据</div>
      <div v-for="(item,index) in items" :key="index" class="site-item" @click="infoWindowOpen(item)">
        <p class="info">站点名称：{{titles[index] || item.title || "未知"}}</p>
        <p class="info">站点地址：{{address[index] || item.address || "-"}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
export default {
  data() {
    return {
      items: [],
      titles: [],
      address: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let querystring = require("querystring");
      let token = "";
      try { 
        const u = common.getUserInfo();
        token = (u && u.token) ? u.token : "";
      } catch(e){}
      this.$api.post("wx/siteList", querystring.stringify({ token }))
        .then(({data}) => {
          if (data && data.status === 1 && Array.isArray(data.data)) {
            this.items = data.data.map(s => ({ title: s.site_name, address: s.address || s.area || "" }));
            this.titles = this.items.map(i=>i.title);
            this.address = this.items.map(i=>i.address);
          }
        }).catch(()=>{});
    },
    infoWindowOpen(item) {
      common.toast(item.title || "站点详情");
    }
  }
};
</script>

<style>
.site {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f2f2f2;
}
.site-header {
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  font-size: 32px;
  border-bottom: 1px solid #eee;
}
.site-tip { color: #999; font-size: 26px; }
.site-list { flex: 1; padding: 20px; }
.site-item {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}
.empty { text-align: center; color: #999; margin-top: 100px; font-size: 30px; }
.info{ line-height: 48px; margin: 0; font-size: 28px; }
</style>


// WEBPACK FOOTER //
// src/components/siteList.vue